import { useContext } from 'react';
import { FootnoteReferenceStateContext } from '../components/FootnoteReferenceContext';
export const useFootnoteReferenceState = () => {
    const state = useContext(FootnoteReferenceStateContext);
    if (state === undefined) {
        throw new Error('useFootnoteReferenceState must be used within a FootnoteReferenceContextProvider');
    }
    return state;
};
